import React, { Fragment } from 'react';

import ShowIcon from '@usas/ui-web/components/icons/ShowIcon';
import HideIcon from '@usas/ui-web/components/icons/HideIcon';

import global from '@usas/ui-web/components/GlobalStyle.module.css';

const DetailTableRow = ({ pool }) => {
  return (
    <tr>
      <td>{pool.facilityPoolName}</td>
      <td>{pool.poolDimensions?.dimensionName}</td>
    </tr>
  );
};

const DetailTable = ({ facility }) => (
  <table className={global.DetailTable}>
    <thead>
      <tr>
        <th>Pool Name</th>
        <th>Pool Dimensions</th>
      </tr>
    </thead>
    <tbody>
      {facility.facilityPool.map((pool, i) => <DetailTableRow pool={pool} key={i} />)}
    </tbody>
  </table>
);

const TableRow = ({ orgUnitFacility, expandedId, onClick }) => {
  return (
    <Fragment>
      <tr key={orgUnitFacility.facility?.facilityId}>
        <td >{orgUnitFacility.facility?.facilityName}</td>
        <td >{orgUnitFacility.facility?.city}</td>
        <td >{orgUnitFacility.facility?.stateCode}</td>
        <td >{orgUnitFacility.facility?.postalCode}</td>
        <td >{orgUnitFacility.facility?.address1}</td>
        <td>{orgUnitFacility.trainingFacility === true ? 'Training' : 'Competition'}</td>
        <td>
          <button
            className={global.IconButtonMargin}
            type="button"
            onClick={(e) => onClick(e, orgUnitFacility.facility.facilityId)}>
            {expandedId === orgUnitFacility.facility.facilityId ? <HideIcon /> : <ShowIcon />}
          </button>
        </td>
      </tr>
      {Array.isArray(orgUnitFacility.facility.facilityPool) && orgUnitFacility.facility.facilityPool.length > 0 && expandedId === orgUnitFacility.facility.facilityId &&
        <tr className={global.Expanded}>
          <td colSpan="7">
            <DetailTable facility={orgUnitFacility.facility} />
          </td>
        </tr>}
    </Fragment>
  );
};

const LargeTeamFacilityReadGrid = ({ state, expandedId, onClick }) => (
  <Fragment>
    <table className={[global.UsasTable, 'visible-lg visible-md'].join(' ')}>
      <thead>
        <tr>
          <th>Facility Name</th>
          <th>City</th>
          <th>State</th>
          <th>Zip Code</th>
          <th>Address</th>
          <th>Purpose</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        {state.isObjLoaded !== true
          ? (<tr>
            {state.isObjLoading === true
              ? <td colSpan="7">Loading...</td>
              : <td colSpan="7">No Facilities</td>}
          </tr>)
          : Array.isArray(state.objData.orgUnitFacility)
            && state.objData.orgUnitFacility.length > 0
            ? state.objData.orgUnitFacility.map((orgUnitFacility, i) =>
              <TableRow orgUnitFacility={orgUnitFacility} key={i} expandedId={expandedId} onClick={onClick} />)
            : (<tr>
              <td colSpan="7">No Facilities</td>
            </tr>)}
      </tbody>
    </table>
  </Fragment>
);

export default LargeTeamFacilityReadGrid;